import * as actionTypes from './actionTypes';
import { modelVehicleService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidate } from '@app/src/common/session';

const fetchModelVehicleRequest = () => ({
  type: actionTypes.FETCH_MODEL_VEHICLE_REQUEST
});

const fetchModelVehicleSuccess = (data) => ({
  type: actionTypes.FETCH_MODEL_VEHICLE_SUCCESS,
  data
});

const fetchModelVehicleFailure = () => ({
  type: actionTypes.FETCH_MODEL_VEHICLE_FAILURE
});

const setModelVehicleMessage = (message?: string) => ({
  type: actionTypes.SET_MODEL_VEHICLE_MESSAGE,
  message
});

export const clearModelVehicleMessage = () => ({
  type: actionTypes.CLEAR_MODEL_VEHICLE_MESSAGE
});

export const clearModelVehicleData = () => ({
  type: actionTypes.CLEAR_MODEL_VEHICLE_DATA
});

export const setModelVehicleSelected = (selected: string) => ({
  type: actionTypes.SET_MODEL_VEHICLE_SELECTED,
  selected
});

export const clearModelVehicleSelected = () => ({
  type: actionTypes.CLEAR_MODEL_VEHICLE_SELECTED
});

export const fetchModelVehicle = (vehicleId: number, brandId: number, modelName?: string): Function => {
  return async dispatch => {
    dispatch(fetchModelVehicleRequest());
    await dispatch(fetchValidate());
    try {
      const data = await modelVehicleService.get(vehicleId, brandId, modelName);
      dispatch(fetchModelVehicleSuccess(data));
      dispatch(setModelVehicleMessage(data && data.length === 0 && 'No se encontraron resultados.'));
    } catch (e) {
      dispatch(fetchModelVehicleFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
